import React from 'react';
import StatusBadge from 'SharedComponent/StatusBadge';
import { ReactComponent as LocationCheckIcon } from '../../assets/icons/location-check-icon.svg';
import { ReactComponent as LocationCrossIcon } from '../../assets/icons/location-cross-icon.svg';
import { GEOFENCE_STATUS } from 'constants/CommonConstants';
import { TextConstants } from 'constants/TextConstants';

const GEOFENCE_BADGE_CONFIG: Record<string, { icon: React.ComponentType<any>; label: string; variant: 'success' | 'danger' }> = {
  [GEOFENCE_STATUS.INSIDE]: { icon: LocationCheckIcon, label: TextConstants.INSIDE_GEOFENCE, variant: 'success' },
  [GEOFENCE_STATUS.OUTSIDE]: { icon: LocationCrossIcon, label: TextConstants.OUTSIDE_GEOFENCE, variant: 'danger' },
};

interface GeofenceBadgeProps {
  status?: GEOFENCE_STATUS | null;
}

const GeofenceBadge: React.FC<GeofenceBadgeProps> = ({ status }) => {
  if (!status || !Object.hasOwn(GEOFENCE_BADGE_CONFIG, status)) {
    return null;
  }

  const badge = GEOFENCE_BADGE_CONFIG[status];

  return <StatusBadge icon={badge.icon} label={badge.label} variant={badge.variant} />;
};

export default GeofenceBadge;
